<template>
  <div style="padding: 0 !important; height: 100% !important;">
    <v-container class="onboard-container" fluid>
      <v-row style="height: 100% !important;">
        <!-- Steps Data !-->
        <v-col class="left-pane" cols="7">
          <v-row style="height: 10%" align="center">
            <div>
              <p class="brought-to-you my-0">{{ $t('broughtToYou') }}</p>
              <v-img :src="partnerImage" contain position="left" max-width="100"/>
            </div>
          </v-row>
          <v-row style="height: 80%" align="center">
            <div>
              <v-form v-if="step === 1" v-model="validBasic">
                <h2>{{ $t('steps.1.headOne') }}</h2>
                <h1>{{ $t('steps.1.headTwo') }}</h1>
                <v-spacer class="my-5"/>
                <v-text-field class="basic-element" :label="$t('form.firstName.label')"
                              :rules="firstNameRules" v-model="firstName" outlined/>
                <v-text-field class="basic-element" :label="$t('form.lastName.label')"
                              :rules="lastNameRules" v-model="lastName" outlined/>
                <v-text-field class="basic-element" :label="$t('form.username.label')"
                              :rules="usernameRules" v-model="username" outlined/>
              </v-form>
              <v-form v-if="step === 2" v-model="validExperience">
                <h2>{{ $t('steps.2.headOne') }}</h2>
                <h1>{{ $t('steps.2.headTwo') }}</h1>
                <v-spacer class="my-5"/>
                <v-autocomplete class="basic-element" :items="countries"
                                :label="$t('form.country.label')" :rules="countryRules" v-model="country" item-text="name" item-value="name" outlined/>
                <v-select class="basic-element" :items="traderTypes" item-text="text" item-value="value"
                          :label="$t('form.typeOfTrading.label')" :rules="typeOfTradingRules" v-model="traderType" outlined/>
                <v-select class="basic-element" :items="experiences" item-text="text" item-value="value"
                          :label="$t('form.experience.label')" :rules="experienceRules" v-model="traderExperience" outlined/>
              </v-form>
              <v-form v-if="step === 3" v-model="validSync">
                <h2>{{ $t('steps.3.headOne') }}</h2>
                 <h1>{{ $t('steps.3.headTwo', {partnerShortName: $store.state.whitelabel.partner.shortName}) }}</h1>
                <v-chip class="my-1" color="calmGreen"><p class="chip-text" v-html="$t('steps.3.chip')"/></v-chip>
                <v-spacer class="my-10"/>
                <div class="d-flex align-start justify-start">
                  <v-select class="basic-element" :items="mtServers" item-text="name" item-value="value" return-object
                            :label="$t('form.mtServer.label', {partnerShortName:$store.state.whitelabel.partner.shortName})" :rules="mtServerRules" v-model="mtServer" outlined/>
                  <v-icon class="icon mt-4" color="primary" small @click="findOutSomething('mtServer')">fa-circle-info</v-icon>
                </div>
                <div class="d-flex align-start justify-start">
                  <v-text-field class="basic-element" :label="$t('form.mtLogin.label')"
                                :rules="mtLoginRules" v-model="mtLogin" outlined/>
                  <v-icon class="icon mt-4" color="primary" small @click="findOutSomething('mtLogin')">fa-circle-info</v-icon>
                </div>
                <div v-if="showInvestorPasswordField" class="d-flex align-start justify-start">
                  <v-text-field class="basic-element" :label="$t('form.mtInvestorPassword.label')"
                                :rules="mtInvestorPasswordRules" v-model="mtInvestorPassword" outlined/>
                  <v-icon class="icon mt-4" color="primary" small @click="findOutSomething('mtInvestorPassword')">fa-circle-info</v-icon>
                </div>
              </v-form>
              <v-btn v-if="step === 2" class="back-button mr-3 mt-3" @click="goBack">{{ $t(`steps.${step}.btnBack`) }}</v-btn>
              <v-btn class="submit-button mt-3" @click="goContinue">{{ $t(`steps.${step}.btnContinue`) }}</v-btn>
            </div>
          </v-row>
          <v-row style="height: 10%" align="end">
            <v-progress-circular color="calmGreen" :value="step * 34"/>
            <p class="ml-3 my-1" v-html="$t('stepProgress', { current: step, total: 3 })"/>
          </v-row>
        </v-col>

        <!-- Steps Animation !-->
        <v-col class="right-pane" cols="5">
          <v-row style="height: 100%" align="end" justify="center">
            <lottie :options="lottieOptions" :height="560"/>
          </v-row>
        </v-col>
      </v-row>

      <!-- More Explanation !-->
      <v-overlay :dark="false" v-model="overlayExplanation">
        <FindOutSomething :resource="explanationResource"
                          :title="explanationTitle"
                          :description="explanationDescription"
                          @close="overlayExplanation = false"/>
      </v-overlay>

      <!-- Sync Attempt !-->
      <v-overlay :dark="false" v-model="overlaySyncAttempt">
        <SyncAttempt :login="mtLogin" :server="mtServer.host" :investor-password="mtInvestorPassword"
                     :account-type="brokerAccountType" @close="overlaySyncAttempt = false"/>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import * as animationData from "@/assets/animations/onboard-astronaut.json";

import AuthRepository from '../../repositories/auth'
import PartnerRepository from '../../repositories/partner';
import BrokerAccountRepository from '../../repositories/brokerAccount'
import MetaTraderCredentialsRepository from '../../repositories/metaTraderCredentials'
import MetaTraderServerDetailsRepository from '../../repositories/metaTraderServerDetails'
import CognitoAuthRepository from "../../repositories/cognitoAuth"
import Countries from '../Register/countries';
import FindOutSomething from "@/components/FindOutSomething.vue";
import SyncAttempt from "@/views/Onboard/components/SyncAttempt.vue";
import { mapMutations } from "vuex";
import PostAfiliatesUtilites from '../../services/referalProgramUtiliities';
import WhitelabelRepository from '../../repositories/whitelabel';
export default {
  name: "OnboardIndex",
  components: {SyncAttempt, FindOutSomething},
  data() {
    return {
      lottieOptions: { animationData: animationData.default, },
      partnerImage: this.$store.state.whitelabel.partner.fullLogoUrl,
      countries: Countries,
      traderTypes: [
        { text: 'Swing Trader', value: 'Swing Trader' },
        { text: 'Day Trader', value: 'Day Trader' },
        { text: 'Core Trader', value: 'Core Trader' },
        { text: this.$t('categories.traderTypes.highFrequencyTrader'), value: 'High-Frecuency Trader' },
        { text: this.$t('categories.traderTypes.iDontKnow'), value: 'I don\'t know' },
      ],
      experiences: [
        { text: this.$t('categories.experiences.learning'), value: 'LEARNING' },
        { text: this.$t('categories.experiences.demo'), value: 'TRADING_DEMO' },
        { text: this.$t('categories.experiences.realNoProfit'), value: 'TRADING_REAL_WITHOUT_PROFIT' },
        { text: this.$t('categories.experiences.profitSixMonths'), value: 'PROFIT_LESS_6_MONTHS' },
        { text: this.$t('categories.experiences.profitConsistent'), value: 'PROFIT_MORE_6_MONTHS' },
      ],
      mtServers: [],

      step: 1,
      firstName: '',
      lastName: '',
      username: '',
      country: '',
      traderType: '',
      traderExperience: '',
      mtServer: {},
      mtLogin: '',
      mtInvestorPassword: '',
      brokerAccountType: '',

      // Validations
      validBasic: false,
      firstNameRules: [
        p => !!p || this.$t('form.firstName.mandatory'),
      ],
      lastNameRules: [
        p => !!p || this.$t('form.lastName.mandatory'),
      ],
      usernameRules: [
        u => !!u || this.$t('form.username.mandatory'),
        u => (u || '').length < 35 || this.$t('form.username.maxLength'),
        u => !u.includes('@') || this.$t('form.username.not1'),
        u => !u.includes('&') || this.$t('form.username.not2'),
        u => (u.split(' ').length <= 1) || this.$t('form.username.not3'),
      ],
      countryRules: [
        c => !!c || this.$t('form.country.mandatory'),
      ],
      typeOfTradingRules: [
        t => !!t || this.$t('form.typeOfTrading.mandatory'),
      ],
      experienceRules: [
        e => !!e || this.$t('form.experience.mandatory'),
      ],
      mtServerRules: [
        mts => !!mts || this.$t('form.mtServer.mandatory'),
      ],
      mtLoginRules: [
        mtl => !!mtl || this.$t('form.mtLogin.mandatory'),
      ],
      mtInvestorPasswordRules: [
        mtl => !!mtl || this.$t('form.mtInvestorPassword.mandatory'),
      ],

      validExperience: false,
      validSync: false,

      // Explanation
      overlayExplanation: false,
      explanationResource: '',
      explanationTitle: '',
      explanationDescription: '',

      // Sync Attempt
      overlaySyncAttempt: false,

      // Investor password
      showInvestorPasswordField: this.$store.state.whitelabel.isInvestorPasswordRequired,
    }
  },
  watch: {
    mtServer() {
      this.brokerAccountType = this.mtServers.find((s) => s.name === this.mtServer.name).type;
    }
  },
  async mounted() {
    /* eslint-disable no-console */
    this.mtServers = (await MetaTraderServerDetailsRepository.getMetaTraderServersByPartner(this.$store.state.whitelabel.partner.id)).data
    let logged = this.$store.state.token !== ''
    if(logged) { // Comes from the passwordless checking or the embedIndex embed after being logged
      let brokerAccountsByPartner = (await BrokerAccountRepository.allBrokerAccountsOfUser()).data
      if(brokerAccountsByPartner.length > 0) { // User already has broker accounts with partner!
        // Go to dashboard babe
        if(this.$store.state.whitelabel !== null && this.$store.state.whitelabel.partner !== null){
          await WhitelabelRepository.updateUserProForwhitelabel(this.$store.state.whitelabel.partner.id)
        }
        await this.$router.push('/dashboard');
      }else{
        let usageState = this.$store.state.user.details.usageState
        if(usageState === 'PRE_REGISTERED'){
          // Go to step 2 to continue onboarding
          this.step = 2
        } else { // otherwise we force the user to insert an account
          this.step = 3
        }
      }
    } else { // if currentUser is not defined, It is a new user, does not have account on swiset, proceed normally from step 1
      this.step = 1 
    }
    /* eslint-enable no-console */
  },
  methods: {
    goContinue() {
      switch (this.step) {
        case 1:
          this.validateAndCollapsedRegisterUser();
          break;
        case 2:
          this.completeUserAndExperienceData();
          break;
        case 3:
          this.connectMetaTrader();
          break;
      }
    },
    goBack() {
      this.step--;
    },
    findOutSomething(goal) {
      this.overlayExplanation = true;
      switch (goal) {
        case 'mtServer':
          this.explanationResource = 'https://hub.swiset.com/wp-content/uploads/2023/06/Swiset-MT-Server-Hint.png';
          this.explanationTitle = this.$t(`form.${goal}.explanation.title`, {partnerShortName:this.$store.state.whitelabel.partner.shortName});
          this.explanationDescription = this.$t(`form.${goal}.explanation.description`);
          break;
        case 'mtLogin':
          this.explanationResource = 'https://hub.swiset.com/wp-content/uploads/2023/06/Swiset-MT-Login-Hint.png';
          this.explanationTitle = this.$t(`form.${goal}.explanation.title`);
          this.explanationDescription = this.$t(`form.${goal}.explanation.description`);
          break;
        case 'mtInvestorPassword':
          this.explanationResource = 'https://hub.swiset.com/wp-content/uploads/2023/06/Swiset-MT-Server-Hint.png';
          this.explanationTitle = this.$t(`form.${goal}.explanation.title`);
          this.explanationDescription = this.$t(`form.${goal}.explanation.description`);
          break;
      }
    },
    trackRegisterAfiliate(refererId, userEmail){
      const postAfiliateCampaingId = this.$store.state.whitelabel.partner !== null ? process.env.VUE_APP_POSTAFFILIATE_WL_CAMPAIGN_ID:process.env.VUE_APP_POSTAFFILIATE_CAMPAIGN_ID;
      PostAfiliatesUtilites.registerTracking(refererId,postAfiliateCampaingId,userEmail );
    },
    ...mapMutations(['setUser']),
    async validateAndCollapsedRegisterUser() {
      if(this.validBasic) {
        const username = (await AuthRepository.getUsernameFromEmail(this.$store.state.whitelabel.userEmail)).data
        if(username) {
          this.$router.push({name: 'passwordless-checking'})
        } else {
          // Get reCAPTCHA token
          const { getRecaptchaToken } = await import('../../services/recaptcha');
          const recaptchaToken = await getRecaptchaToken('register_collapsed');
          
          AuthRepository.existingUsernameOrEmail(this.username, this.$store.state.whitelabel.userEmail).then(async (response) => {
            if (response.status < 400) {
              let data = response.data;
              if (data === -1) {
                const randomString = (n) => [...Array(n)].map(() => {
                  const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                  return charSet.charAt(Math.floor(Math.random() * charSet.length));
                }).join('');
                let userData = {
                  email: this.$store.state.whitelabel.userEmail,
                  firstName: this.firstName,
                  lastName: this.lastName,
                  username: this.username,
                  password: randomString(30),
                  activate: true,
                  referredFrom : this.$store.state.whitelabel.partner.shortName,
                  recaptchaToken: recaptchaToken,
                }
                await AuthRepository.registerCollapsedUser(userData).then(async (res) => {
                  let user = res.data
                  this.setUser(user)
                  let email = this.$store.state.whitelabel.userEmail
                  const result = await CognitoAuthRepository.createCognitoAuthFromSwisetUser(email,email)
                  if(!result) {
                    alert("Failed registration to Authprovider from existing user")
                  }else{
                    this.$router.push({name: 'passwordless-checking'})
                  }
                })
              }
              else alert(this.$t('form.username.existingIssue'));
            }
          });
        }
      }
      else alert(this.$t('formIssue'));
    },
    ...mapMutations(['setCompletedRegister']),
    completeUserAndExperienceData() {
      if(this.validExperience) {
        let userData = {
          userId: this.$store.state.user.id,
          firstName: this.$store.state.user.firstName,
          lastName: this.$store.state.user.lastName,
          username: this.$store.state.user.username,
          phoneNumber: '', // Think later
          country: this.country,
          typeOfTrader: this.traderType,
          previousExperience: this.traderExperience,
          channel: 'Whitelabel',
        };

        AuthRepository.completeUserRegister(userData).then( async (response) => {
          if (response.status < 400 && response.data) {
            this.setCompletedRegister(userData);
            window.sendinblue.identify(this.$store.state.user.email, {
              'NOMBRE': this.$store.state.user.firstName,
              'SURNAME': this.$store.state.user.lastName,
              'USERNAME': this.$store.state.user.username,
              'PHONE': '',
              'COUNTRY': this.country,
              'PRO_ON': '0',
              'LANG': this.$i18n.locale,
              'CHANNEL': 'Whitelabel',
            });
            window.sendinblue.track('fullRegister');
            window.fbq('track', 'CompleteRegistration');
            this.step = 3
          }
        });
      }
      else alert(this.$t('formIssue'));
    },
    ...mapMutations(['setIsPro']),
    connectMetaTrader() {
      /* eslint-disable no-console */
      if(this.validSync) {
        this.overlaySyncAttempt = true;
        let metatraderCredentialsFromPartner = {
          server: this.mtServer.host,
          serverName: this.mtServer.name,
          login: this.mtLogin,
          investorPassword: this.mtInvestorPassword,
          partnerId: this.$store.state.whitelabel.partner.id,
          version: this.mtServer.version,
          platform: this.$store.state.whitelabel.platform.name
        }
        MetaTraderCredentialsRepository.createCredentialsFromPartner(metatraderCredentialsFromPartner).then(async (res) => {
          if(res.status<400){
            await MetaTraderCredentialsRepository.updateAllTradesForMetaTraderCredential(res.data).then((response) => {
              if(response.status < 400)
                PartnerRepository.verifyProUpgradeByPartner(this.$store.state.whitelabel.partner.id);
            });
            this.trackRegisterAfiliate(this.$store.state.whitelabel.partner.shortName,this.$store.state.whitelabel.userEmail);
            await this.$router.push('/dashboard');
          }else{
            alert(this.$t('formIssue'));
            this.showInvestorPasswordField = true;
          }
          this.overlaySyncAttempt = false
        }).catch((err) => {
          console.log(err)
          alert(this.$t('formIssue'));
          this.showInvestorPasswordField = true;
          this.overlaySyncAttempt = false
        })
      } else {
        alert(this.$t('formIssue'));
      }
      /* eslint-enable no-console */
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

.onboard-container {
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.left-pane {
  padding: 2.5% 4% 2.5% 5%;
}

.right-pane {
  padding: 0;
  background-color: $black-color;
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: right;
}

.brought-to-you {
  color: $border-color;
}

.basic-element {
  max-width: 25vw;
}

.chip-text {
  margin-bottom: 0;
  color: #247851;
  font-size: 14px;
}
</style>

